import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { translate } from 'react-i18next';

import Button from '../../common/Button';
import InputPrimary from '../../common/InputPrimary';

const InputName = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const InputEmail = (field) => (
  <InputPrimary
    type="email"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const InputUrls = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-huge"
    align="left"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const languages = [
  { value: 'en', label: 'English' },
  { value: 'bg', label: 'Български' },
];
const LanguageSelect = (field) => (
  <Select
    isSearchable={false}
    classNamePrefix="c-select"
    className="u-margin-bottom-huge u-z-index-on-top"
    value={languages.find((l) => l.value === field.input.value)}
    onChange={(selectedOption) => field.input.onChange(selectedOption.value)}
    name={field.input.name}
    options={languages}
    {...field}
  />
);

export const FieldFileInput = (field) => (
  <div className="u-margin-bottom-huge">
    <label
      htmlFor={field.input.name}
      className={`c-input__label u-padding-bottom-tiny`}
    >
      {field.label}
    </label>
    <input
      type="file"
      accept=".jpg, .png, .jpeg, .gif"
      onChange={(e) => {
        field.input.onChange(e.target.files[0]);

        // TODO: Image preview
        // document.getElementById(
        //   'avatarUrlPreview'
        // ).src = window.URL.createObjectURL(e.target.files[0]);
      }}
      name={field.input.name}
      {...field}
    />
  </div>
);

let Form = ({
  handleSubmit,
  onSubmit,
  submitting,
  error,
  okButtonText,
  t,
  enableEmailInput,
  avatarUrl,
}) => (
  <form onSubmit={handleSubmit}>
    <Field
      component={InputName}
      name="name"
      label={t('user.edit.nameLabel')}
      placeholder={t('user.edit.namePlaceholder')}
      required
    />
    <Field
      component={InputEmail}
      name="email"
      label={t('user.edit.emailLabel')}
      disabled={!enableEmailInput}
      required
    />
    <label htmlFor="lang" className="c-input__label u-padding-bottom-tiny ">
      {t('user.edit.lang')}
    </label>
    <Field name="lang" component={LanguageSelect} />

    <Field
      component={FieldFileInput}
      name="avatarUrl"
      label={t('user.edit.avatarLabel')}
      placeholder={t('user.edit.avatarPlaceholder')}
    />
    {/* <img id="avatarUrlPreview" alt="Avatar" width="200" height="200" /> */}

    {/* TODO: Use the component below to input urls */}
    <Field
      component={InputUrls}
      name="urls"
      label={t('user.edit.urlsLabel')}
      placeholder={t('user.edit.urlsPlaceholder')}
    />
    {/* <h3 className="c-heading--alpha u-margin-top-large">Links to more details</h3>
    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <span className="c-input-url__icon"></span>
      <textarea type="text" className="c-input c-input-url" placerholder="Add URL" rows="1">https://gitlab.com/dev-labs-bg/chuzdhitsa-website</textarea>
    </div>
    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <span className="c-input-url__icon"></span>
      <textarea type="text" className="c-input c-input-url" placerholder="Add URL" rows="1">https://trello.com/chuzdhitsa-bg</textarea>
    </div>
    <button className="c-btn c-btn-outline">+ new link
    </button> */}

    <div className="u-margin-top-huge u-text-center">
      <Button disbaled={submitting ? 1 : 0} type="submit">
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>

    {error && <p className="c-alert c-alert--danger u-margin-top">{error}</p>}
  </form>
);

Form = reduxForm({ form: 'user-edit' })(translate()(Form));

const selector = formValueSelector('user-edit');
Form = connect((state) => ({
  avatarUrl: selector(state, 'avatarUrl'),
}))(Form);

export default Form;



// WEBPACK FOOTER //
// ./src/user/edit/Form.js